import moment from "moment";

export function dateTimeFormat(time){
    return moment.utc(time).local().format("DD.MM.YYYY HH:mm:ss")
}